import React, { useState, useEffect } from "react";
import {
  getAllChargingSites,
  addDriverChargingSite,
} from "../../actions/commonActions";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import Loading from "./Loading";

const NewSiteModal = ({ setAddNewSite }) => {
  const dispatch = useDispatch();

  const { allChargingSites, driverChargingSites } = useSelector(
    (redux) => redux.common
  );

  const [chargingSites, setChargingSites] = useState([]);

  const [selectedChargingSite, setSelectedChargingSite] = useState("");

  const [driverChargingSiteIds, setDriverChargingSiteIds] = useState([]);

  useEffect(() => {
    getAllChargingSites(dispatch);
  }, []);

  useEffect(() => {
    const filteredChargingSites = allChargingSites.filter(
      (site) => !driverChargingSiteIds.includes(site.ev_charging_site_id)
    );
    setChargingSites(filteredChargingSites);
  }, [allChargingSites]);

  useEffect(() => {
    setDriverChargingSiteIds(
      driverChargingSites.map((site) => site.ev_charging_site_id)
    );
  }, [driverChargingSites]);

  const onSubmit = () => {
    addDriverChargingSite(
      dispatch,
      {
        ev_charging_site_id: selectedChargingSite,
      },
      () => {
        setAddNewSite(false);
      }
    );
  };

  const onModalClose = () => {
    setAddNewSite(false);
  };

  return (
    <div>
      <Modal show={true} centered onHide={onModalClose}>
        <Modal.Header>
          <h5 className="modal-title">Add New Charging Site</h5>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            onClick={onModalClose}
          >
            &times;
          </button>
        </Modal.Header>
        <Modal.Body>
          {(chargingSites.length > 0 && (
            <select
              className="custom-select"
              onChange={(e) => {
                setSelectedChargingSite(e.target.value);
              }}
            >
              <option value=""> Select Charging Station</option>
              {chargingSites.map((site) => (
                <option value={site.ev_charging_site_id}>{site.name}</option>
              ))}
            </select>
          )) || (
            <div className="row justify-content-center align-items-center">
              <Loading />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-info btn-sm "
            onClick={() => {
              onSubmit();
            }}
          >
            Save
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default NewSiteModal;
